import { AppConfig } from './../../app.config';
import { SnapshotService } from './../../snapshot/snapshot.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Correction } from '@liquitics/transaction';
import { CorrectionService } from './../correction.service';
import { CommunicationService } from '../../common/communication.service';
import { ProjectionService } from '../../projection/projection.service';

@Component({
    selector: 'app-account-balance-adjustment',
    templateUrl: './account-balance-adjustment.component.html',
    styleUrls: ['./account-balance-adjustment.component.css']
})
export class AccountBalanceAdjustmentComponent implements OnInit {
    currencies: string[];
    desks: string[] = [];
    submitResult: string;

    correctionFormGroup: FormGroup;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        private snapshotService: SnapshotService,
        private correctionService: CorrectionService,
        private communicationService: CommunicationService,
        private projectionService: ProjectionService,
        private appConfig: AppConfig) {
        this.currencies = this.appConfig.activeUserProfile.getCurrencies();
        this.desks = snapshotService.applicationConfiguration.desks;
    }

    ngOnInit() {
        this.correctionFormGroup = new FormGroup({
            'currency': new FormControl(this.data.correction.currency, [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(3),
                currencyValidator(this.currencies),
            ]
            ),
            'desk': new FormControl(this.data.correction.desk, [
                Validators.required,
            ]
            ),
            'changeReason': new FormControl(this.data.correction.changeReason, [
                Validators.required,
            ]
            ),
        });
    }

    submit() {
        const correction: Correction = this.data.correction;
        correction.direction = (correction.amount > 0) ? 'REC' : 'PAY';
        this.correctionService
            .saveCorrection(this.data.correction)
            .then(() => {
                this.communicationService.openSnackBar('Submission Successful', 'Ok');
            })
            .catch((err: any) => {
                this.communicationService.openSnackBar('Submission Failed', 'Dismiss');
            })
            ;

    }

    get currency() {
        return this.correctionFormGroup.get('currency');
    }

    get desk() {
        return this.correctionFormGroup.get('desk');
    }

    get changeReason() {
        return this.correctionFormGroup.get('changeReason');
    }

}

export function currencyValidator(currencies: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const isValid = currencies.includes(String(control.value).toUpperCase());
        return !isValid ? { 'invalidCurrency': { value: control.value } } : null;
    };
}

